'use strict';

app.config(function ($provide) {
  $provide.decorator('$browser', function ($delegate) {
    var nativeUrl = $delegate.url;
    $delegate.url = function (url, replace, state) {
      if (!url) {
        return nativeUrl(url, replace, state).replace(/(#.+)|#$/, '$1');
      } else {
        return nativeUrl(url, replace, state);
      }
    };
    return $delegate;
  });
});

app.run(function (rmModals) {
  rmModals.init();
});

app.service('rmModals', function ($window, $document, $timeout, $location, $rootScope, $interval) {

  $location.hash('');

  var body = $document.find('body');
  var overlay = angular.element('<div class="modal-overlay"></div>');
  var pointer = angular.element('<div class="modal-pointer"></div>');
  var viewport = angular.element('<div class="modal-viewport"></div>');

  overlay.on('click', function () {
    $timeout(function () {
      $location.hash('$');
    });
  });

  var modals = {};
  var current;

  var open = function () {
    body.append(overlay);
    if (current.anchor) {
      current.anchor.addClass('active');
      viewport.removeClass('rm-modal-popup').addClass('rm-modal-popover');
      pointer.removeClass('top');
      var rect = current.anchor[0].getBoundingClientRect();
      var bottom = body[0].offsetHeight - $window.pageYOffset - rect.top;
      var center = $window.pageXOffset + rect.left + rect.width / 2;
      var maxWidth = 500;
      var bodyWidth = body[0].offsetWidth;
      var left = 0;
      if ($window.pageXOffset + bodyWidth > maxWidth) {
        left = center - maxWidth / 2;
        left = Math.max($window.pageXOffset, Math.min(left, $window.pageXOffset + bodyWidth - maxWidth));
      }
      center = Math.max(left + 35, Math.min(center, left + Math.min(maxWidth, bodyWidth) - 35));
      viewport.css({
        top: '',
        left: left + 'px',
        bottom: bottom + 8 + 'px'
      });
      pointer.css({
        top: '',
        left: center + 'px',
        bottom: bottom + 'px'
      });
      body.append(pointer);
    } else {
      viewport.removeClass('rm-modal-popover').addClass('rm-modal-popup');
    }
    body.append(viewport);

    var reposition = function (modal) {
      if (!current.anchor) {
        // if the modal windows isn't bounded to an anchor point - do nothing
        return angular.noop;
      }
      var lastTop;
      var fixPosition = function () {
        var modalBounds = modal[0].getBoundingClientRect();
        if (false && modalBounds.top === lastTop) {
          //nothing was changed, skip
          return;
        }
        var anchorBounds = current.anchor[0].getBoundingClientRect();
        var body = document.body;
        var docEl = document.documentElement;
        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var top  = anchorBounds.bottom +  scrollTop - clientTop;
        var maxWidth = 500;
        var bodyWidth = body.offsetWidth;
        var left = 0;
        if ($window.pageXOffset + bodyWidth > maxWidth) {
          left = center - maxWidth / 2;
          left = Math.max($window.pageXOffset, Math.min(left, $window.pageXOffset + bodyWidth - maxWidth));
        }
        center = Math.max(left + 35, Math.min(center, left + Math.min(maxWidth, bodyWidth) - 35));
        if (modalBounds.top < 0) {
          viewport.css({
            left: left,
            bottom: '',
            top: top + modalBounds.height + 16 + 'px'
          });
          pointer.css({
            left: center,
            bottom: '',
            top: top + 8 + 'px'
          });
          pointer.addClass('top');
        }
        lastTop = modalBounds.top;
      };
      var refreshInterval = $interval(fixPosition, 100);
      return function () {
        $interval.cancel(refreshInterval);
        pointer.removeClass('top');
      };
    };
    var innerScope = current.scope.$new();
    current.transclude(innerScope, function (clone) {
      clone.addClass('modal-window');
      var cancelReposition = angular.noop;
      if (!$rootScope.alc) {
        clone.css({visibility: 'hidden'});
        pointer.css({visibility: 'hidden'});
        cancelReposition = reposition(clone);
        $timeout(function () {
          clone.css({visibility: ''});
          pointer.css({visibility: ''});
        }, 300, false);
      }
      viewport.append(clone);

      clone.on('$destroy', function () {
        innerScope.$destroy();
        cancelReposition();
      });
    });

  };

  var close = function () {
    viewport.detach().empty();
    pointer.detach();
    overlay.detach();
    if (current.anchor) {
      current.anchor.removeClass('active');
    }
  };

  this.addModal = function (name, transclude, scope) {
    modals[name] = modals[name] || {};
    modals[name].transclude = transclude;
    modals[name].scope = scope;
    scope.$on('$destroy', function () {
      modals[name] = null;
    });
  };

  this.addModalLink = function (name, element) {
    modals[name] = modals[name] || {};
    modals[name].anchor = element;
  };

  this.init = function () {
    $rootScope.$on('$locationChangeSuccess', function () {
      if (current) { close(); }
      current = modals[$location.hash()];
      if (current) { open(); }
    });
  };

});

app.directive('rmModal', function (rmModals) {
  return {
    transclude: 'element',
    priority: 600,
    link: function (scope, element, attrs, ctrl, transclude) {
      var name = scope.$eval(attrs.rmModal);
      rmModals.addModal(name, transclude, scope);
    }
  };
});

app.directive('rmModalLink', function ($timeout, $location, rmModals) {
  return {
    link: function (scope, element, attrs) {
      var name = scope.$eval(attrs.rmModalLink);
      rmModals.addModalLink(name, element);
      element.on('click', function () {
        $timeout(function () {
          $location.hash(name);
        });
      });
    }
  };
});
